module.exports = __webpack_public_path__ + "static/img/index-pro-物业管理.01eec0fb.png";